/**
 * Analytics utilities for cards-list widget
 * Same pattern as client product card analytics
 */

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[] & { hide?: any }
  }
}

/**
 * @description - Push event to GTM
 * Same pattern as client's gtm.pushEvent
 * @see https://developers.google.com/tag-platform/tag-manager/datalayer
 */
export interface PushEventArgs extends Record<string, string | number | Array<Record<string, string | number>>> {
  event: string
  screenName: string
}

/**
 * @description - Push event to GTM
 * Same pattern as client's pushEvent from lib/analytics/push-event.ts
 */
export const pushEvent = (event: PushEventArgs) => {
  if (typeof window === 'undefined') {
    console.warn('Analytics (GTM) events should not be called in server!')
    console.warn(event)

    return
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(event)
}

export const gtm = { pushEvent }

export interface ProductCardClickedArgs {
  productId: string
  name: string
  categoryId: string
  price: number
  currencyIso: string
  date: string
  screenName: string
}

export const productCardRefClicked = (args: ProductCardClickedArgs) => {
  const { productId, name, categoryId, price, currencyIso, date, screenName } = args

  gtm.pushEvent({
    event: 'select_item',
    action: 'select_item',
    ModuleTypeName: categoryId,
    category: categoryId,
    target: 'Product Card Clicked',
    productId,
    itemName: name,
    price: `${price}`,
    currency: currencyIso,
    date,
    screenName,
  })
}

export interface FilterClickedArgs {
  filterName: string
  screenName: string
}

export const filterClicked = (args: FilterClickedArgs) => {
  const { filterName, screenName } = args

  gtm.pushEvent({
    event: 'interaction',
    action: 'click',
    category: 'shows',
    target: 'click on filter',
    label: filterName,
    screenName,
  })
}

export interface EmptyStateButtonClickedArgs {
  screenName: string
}

export const emptyStateButtonClicked = (args: EmptyStateButtonClickedArgs) => {
  const { screenName } = args

  gtm.pushEvent({
    event: 'interaction',
    action: 'click',
    category: 'shows',
    target: 'click on empty state button',
    label: 'לחצו כאן',
    screenName,
  })
}

export interface SeeAllButtonClickedArgs {
  screenName: string
}

export const seeAllButtonClicked = (args: SeeAllButtonClickedArgs) => {
  const { screenName } = args

  gtm.pushEvent({
    event: 'interaction',
    action: 'click',
    category: 'shows',
    target: 'click on see all button',
    label: 'לכל ההופעות',
    screenName,
  })
}
